// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EnumEnvironmentEventType } from './EnumEnvironmentEventType';
import {
  EnumEnvironmentEventTypeFromJSON,
  EnumEnvironmentEventTypeFromJSONTyped,
  EnumEnvironmentEventTypeToJSON,
  EnumEnvironmentEventTypeToJSONTyped,
} from './EnumEnvironmentEventType';

/**
 *
 * @export
 * @interface RequestEnvironmentEvent
 */
export interface RequestEnvironmentEvent {
  /**
   * Cluster name
   * @type {string}
   * @memberof RequestEnvironmentEvent
   */
  cluster?: string;
  /**
   * Mark if the event failed
   * @type {boolean}
   * @memberof RequestEnvironmentEvent
   */
  failed?: boolean;
  /**
   * Human-readable message
   * @type {string}
   * @memberof RequestEnvironmentEvent
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof RequestEnvironmentEvent
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof RequestEnvironmentEvent
   */
  occurredAt?: number;
  /**
   * Component name
   * @type {string}
   * @memberof RequestEnvironmentEvent
   */
  resource?: string;
  /**
   *
   * @type {EnumEnvironmentEventType}
   * @memberof RequestEnvironmentEvent
   */
  type?: EnumEnvironmentEventType;
}

/**
 * Check if a given object implements the RequestEnvironmentEvent interface.
 */
export function instanceOfRequestEnvironmentEvent(
  value: object,
): value is RequestEnvironmentEvent {
  return true;
}

export function RequestEnvironmentEventFromJSON(
  json: any,
): RequestEnvironmentEvent {
  return RequestEnvironmentEventFromJSONTyped(json, false);
}

export function RequestEnvironmentEventFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RequestEnvironmentEvent {
  if (json == null) {
    return json;
  }
  return {
    cluster: json['cluster'] == null ? undefined : json['cluster'],
    failed: json['failed'] == null ? undefined : json['failed'],
    message: json['message'] == null ? undefined : json['message'],
    name: json['name'] == null ? undefined : json['name'],
    occurredAt: json['occurred_at'] == null ? undefined : json['occurred_at'],
    resource: json['resource'] == null ? undefined : json['resource'],
    type:
      json['type'] == null
        ? undefined
        : EnumEnvironmentEventTypeFromJSON(json['type']),
  };
}

export function RequestEnvironmentEventToJSON(
  json: any,
): RequestEnvironmentEvent {
  return RequestEnvironmentEventToJSONTyped(json, false);
}

export function RequestEnvironmentEventToJSONTyped(
  value?: RequestEnvironmentEvent | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cluster: value['cluster'],
    failed: value['failed'],
    message: value['message'],
    name: value['name'],
    occurred_at: value['occurredAt'],
    resource: value['resource'],
    type: EnumEnvironmentEventTypeToJSON(value['type']),
  };
}
